import { render } from "./editarSiniestro.vue?vue&type=template&id=eb5232e6&scoped=true"
import script from "./editarSiniestro.vue?vue&type=script&lang=js"
export * from "./editarSiniestro.vue?vue&type=script&lang=js"

import "./editarSiniestro.vue?vue&type=style&index=0&id=eb5232e6&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\reclasin-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb5232e6"]])

export default __exports__